import * as React from 'react'
import styled from 'styled-components'
import { InputLarge, EllipsisSpan, IntroTextSpan, H1 } from '../../../../common/src/components/core'
import keyboard, { KeyAction } from '../../../../common/src/keyboard'

interface EditHeaderProps {
  header?: string
  subheader?: string
  icon?: JSX.Element
  editText?: string
  onEdit: (value: string) => Promise<any>
}

interface EditHeaderState {
  isEditing: boolean
  hasError: boolean
}

export default class EditHeader extends React.PureComponent<EditHeaderProps, EditHeaderState> {
  private input: HTMLInputElement | null = null
  state = { isEditing: false, hasError: false }

  componentDidMount() {
    keyboard.addListener(this.onKeyboardBound)
  }

  componentWillUnmount() {
    keyboard.removeListener(this.onKeyboardBound)
  }

  render() {
    const { header, subheader, editText, icon } = this.props
    const { isEditing, hasError } = this.state

    let elem
    if (isEditing) {
      elem = (
        <InputLarge
          onKeyDown={this.onKeyDownBound}
          onBlur={this.onBlurBound}
          ref={this.setInputRefBound}
          defaultValue={editText == null ? header : editText}
          hasError={hasError}
        />
      )
      window.requestAnimationFrame(() => {
        if (this.input) {
          this.input.select()
        }
      })
    } else {
      elem = (
        <EditHeaderH1 onClick={this.startEditingBound} className={'edit-header'}>
          <EllipsisSpan>{header}</EllipsisSpan> <IntroTextSpan>{subheader}</IntroTextSpan> {icon}
        </EditHeaderH1>
      )
    }
    return <EditHeaderWrap>{elem}</EditHeaderWrap>
  }

  private onKeyboardBound = (action: KeyAction) => {
    if (action === KeyAction.editName) {
      this.startEditingBound()
    }
  }

  private onKeyDownBound = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.keyCode === 27) {
      // esc
      this.setState({ isEditing: false, hasError: false })
      return
    }
    if (e.keyCode !== 13 || this.input == null) {
      // anything but enter
      return
    }

    const { value } = this.input
    this.props
      .onEdit(value)
      .then(() => this.setState({ isEditing: false, hasError: false }))
      .catch(() => {
        this.setState({ hasError: true })
      })
  }

  private onBlurBound = () => {
    this.setState({ isEditing: false })
  }

  private setInputRefBound = (ref: HTMLInputElement | null) => {
    this.input = ref
  }

  private startEditingBound = () => this.setState({ isEditing: true })
}

const EditHeaderWrap = styled.div`
  height: 64px;
  max-width: 700px;
  overflow: hidden;
`

const EditHeaderH1 = styled(H1)`
  white-space: nowrap;
  width: 0;
`
